module.exports = __webpack_public_path__ + "static/media/conHotspot.60eed324.png";